import { useState } from 'react';

import { useBulkDeleteTrainingSets } from '../../../../redux/api/trainingsAPI';
import { ITrainingSet } from '../../../../types/interfaces/training-set';

export function useCurrentTrainingSetGroup(
  trainingSetGroup: ITrainingSet[],
  trainingId: string,
) {
  const [setGroupDeleting, setSetGroupDeleting] = useState<boolean>(false);
  const [bulkDeleteTrainingSets] = useBulkDeleteTrainingSets();

  const currentSetNumber = trainingSetGroup[0]?.setNumber || 0;

  function onRemoveSetGroup() {
    bulkDeleteTrainingSets({
      trainingId,
      setNumber: currentSetNumber,
    })
      .unwrap()
      .then(() => {
        setSetGroupDeleting(false);
      })
      .catch((e) => console.log(e));
  }

  return {
    setGroupDeleting,
    setSetGroupDeleting,
    onRemoveSetGroup,
  };
}
